














import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import SubmitButton from "@/components/SubmitButton.vue";

@Component({
  components: {
    SubmitButton
  }
})
export default class ToggleItem extends Vue {
  @Prop({ default: false }) readonly value!: boolean;
  private localValue: boolean = this.value;

  @Watch("value", { immediate: true })
  onValueChanged(newVal: boolean) {
    this.localValue = newVal;
  }

  submit() {
    this.$emit("submit", this.localValue);
  }
}
